<template>
  <div id="cooperateinkage">
    <!-- 考区/考点工作人员信息管理 -->
    <!-- <small class="color-gray">考区/考点工作人员信息管理</small> -->
    <div class="mt-4">
      <template>
        <van-button
          type="info"
          size="small"
          class="w-25"
          round
          @click="pushUserList"
          >添 加</van-button
        >
      </template>
      <div>
        <el-form
          label-width="35%"
          label-position="left"
          class="m-4 text-left"
          v-for="(item, index) in userList"
          :key="index"
        >
          <el-form-item size="mini">
            <template slot="label">
              <i class="fa fa-fw fa-map-marker"></i>
              考场号
            </template>
            <template>{{ item.RoomNo }}</template>
          </el-form-item>
          <el-form-item size="mini">
            <template slot="label">
              <i class="fa fa-fw fa-user"></i>
              座位号
            </template>
            <template>{{ item.SeatNo }}</template>
          </el-form-item>
          <el-form-item size="mini">
            <template slot="label">
              <i class="fa fa-fw fa-map-marker"></i>
              违纪情况
            </template>
            <template>{{ item.Memo }}</template>
          </el-form-item>
          <el-form-item size="mini">
            <van-button
              type="info"
              size="small"
              @click="
                getUserList(
                  item.RoomNo,item.SeatNo
                )
              "
              >编 辑</van-button
            >
            <van-button
              type="danger"
              style="margin-left: 10px"
              size="small"
              @click="removeUser(item.RoomNo,item.SeatNo)"
              >删 除</van-button
            >
          </el-form-item>
        </el-form>
        <div class="m-4 pb-4"></div>
      </div>
    </div>
    <!-- 添加考試任務彈出框 -->
    <el-dialog
      title="添加违纪考生"
      :visible.sync="dialogVisible"
      width="90%"
      :before-close="handleClose"
    >
      <span>
        <el-form label-width="40%" label-position="left" class="m-4 text-left">
          <el-form-item size="mini">
            <template slot="label">
              <span style="color: red">*</span>
              考场号
            </template>
            <template>
              <el-input type="text" v-model="RoomNo" size="mini"></el-input>
            </template>
          </el-form-item>
          <el-form-item size="mini">
            <template slot="label">
              <span style="color: red">*</span>
              座位号
            </template>
            <template>
              <el-input type="text" v-model="SeatNo" size="mini"></el-input>
            </template>
          </el-form-item>
          <el-form-item size="mini">
            <template slot="label">
              <span style="color: red">*</span>
              违纪情况
            </template>
            <template>
              <el-input rows="5" type="textarea" v-model="Memo" size="mini"></el-input>
            </template>
          </el-form-item>
        </el-form>
      </span>

      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="preserve">保 存</el-button>
      </span>
    </el-dialog>
    <!-- 編輯彈窗 -->
    <el-dialog
      title="编辑违纪考生"
      :visible.sync="dialogShow"
      width="90%"
      :before-close="handleClose"
    >
      <span v-if="dialogVisibles">
        <el-form label-width="40%" label-position="left" class="m-2 text-left">
          <el-form-item size="mini">
            <template slot="label">
              <span style="color: red">*</span>
              考场号
            </template>
            <template>
              <el-input
                type="text"
                v-model="userSelList.RoomNo"
                size="mini"
                :disabled="true"
              ></el-input>
            </template>
          </el-form-item>
          <el-form-item size="mini">
            <template slot="label">
              <span style="color: red">*</span>
              座位号
            </template>
            <template>
              <el-input
                type="text"
                v-model="userSelList.SeatNo"
                size="mini"
                :disabled="true"
              ></el-input>
            </template>
          </el-form-item>
          <el-form-item size="mini">
            <template slot="label">
              <span style="color: red">*</span>
              违纪情况
            </template>
            <template>
              <el-input
                type="textarea"
                v-model="userSelList.Memo"
                size="mini"
                rows="5"
              ></el-input>
            </template>
          </el-form-item>  
        </el-form>
      </span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogShow = false">取 消</el-button>
        <el-button type="primary" @click="setUser">保 存</el-button>
      </span>
    </el-dialog>
    <!-- 加载数据时显示遮罩层 -->
    <van-overlay :show="overlayshow">
      <div class="wrapper">
        <van-loading vertical>工作任务加载中...</van-loading>
      </div>
    </van-overlay>
  </div>
</template>

<script>
import { Dialog } from "vant";
export default {
  name: "violatediscipline",
  data () {
    return {
      aaaaa: "",
      RollleaderID: -1,
      userList: [],
      dataId: {
        WorkID: this.getWork().WorkID
      },
      userNumList: [],
      userSelList: [],
      roleList: [],
      dialogVisible: false,
      dialogVisibles: false,
      dialogNumShow: false,
      dialogShow: false, //編輯彈窗是否顯示
      overlayshow: false, // 遮罩层
      RoomNo: "",
      SeatNo: "",
      Memo: "",
      incident: "", //1 添加工作人員  2 編輯資料    3  編輯人數
      generalReport: {
        WorkID: "",
        SplitProcessID: "",
        Status: 2,
        Memo: "",
        OrganID: null,
        RoleID: null
      },
      dialogUpload: false,
      organID: "",
      rules: {
        RoomNo: [
          { required: true, message: "考场号为必填项", trigger: "change" }
        ],
        SeatNo: [
          { required: true, message: "座位号为必填项", trigger: "change" }
        ],
        Memo: [{ required: true, message: "违纪情况为必填项", trigger: "change" }]
      }, //表单验证
      upLoadData: {}, //上传数据
      fileList: [], //上传文件列表
      userInfoTable: {}, //选择列表数据
      tableField: {}, //字段数据
      fileName: null, //文件名
      module: "CooperateInkage", //文件保存目录名
      loading: false,
      dialogVisibleErr: false, //错误弹窗
      messageErr: "", //错误提示
      errData: [] //错误数据
    };
  },
  created () {
    this.fetchData();
    this.headers = this.getprocessuserUploadFile();
    this.completeBtnAttribute.disabled = false
    //this.completeBtnAttribute.tips = "需要先添加协同联动人员信息后上报状态";
    //this.verifiupdateData();
  },
  watch: {
    dialogUpload (val) {
      if (val == false) {
        this.dialogUpload = false;
        this.handleClear();
      }
    }
  },
  props: {
    SplitProcessID: String, //分解环节ID
    ProcessData: Object, //工作环节数据
    ProcessRefresh: Function, //工作环节刷新事件
    completeBtnAttribute: Object //工作环节上报完成按钮
  },
  methods: {
    fetchData () {
      this.userList = [];
        this.apireportGetviolatedisciplinelistAPIGet(
          {
            WorkID: this.getWork().WorkID,
            SplitProcessID: this.SplitProcessID
          },
          this,
          res => {
            res.data.forEach(element => {
                this.userList.push(element);
            });
          }
        );
    },
    // 添加按鈕  显示弹窗
    pushUserList () {
      this.dialogVisible = true;
      this.dialogVisibles = true;
    },
    // 編輯按鈕
    getUserList (
      RoomNo,SeatNo
    ) {
      // console.log(Phone);

        this.dialogShow = true;
        this.dialogVisibles = true;
        this.dialogNumShow = false;
        this.apireportGetviolatedisciplineinfoAPIGet(
            {
              WorkID: this.getWork().WorkID,
              SplitProcessID: this.SplitProcessID,
              RoomNo:RoomNo,
              SeatNo:SeatNo
            },
            this,
            res => {
              // eslint-disable-next-line no-console
              // console.log(res);
              this.userSelList = res.data;
              // res.data.forEach(element => {
              //     this.userSelList = element;
              // });
              // eslint-disable-next-line no-console
            }
          );
      
    },
    // 添加工作人员  保存按鈕
    preserve () {
     if (this.RoomNo == "") {
        Dialog.alert({
          title: "提示",
          message: "考场号不能为空"
        }).then(() => {
          // on close
        });
      } else if (this.SeatNo == "") {
        Dialog.alert({
          title: "提示",
          message: "座位号不能为空"
        }).then(() => {
          // on close
        });
      } else if (this.Memo == "") {
        Dialog.alert({
          title: "提示",
          message: "违纪情况不能为空"
        }).then(() => {
          // on close
        });
      } else {
        this.overlayshow = true; // 显示遮罩层
        this.apiReportAddviolatedisciplineinfoAPIGet(
          {
            WorkID: this.getWork().WorkID,
            SplitProcessID: this.SplitProcessID,
            RoomNo: this.RoomNo,
            SeatNo: this.SeatNo,
            Memo: this.Memo
          },
          this,
          res => {
            // console.log(this.userList);
            this.overlayshow = false; // 显示遮罩层
            if (res.code == 20000) {
              this.dialogVisible = false;
              this.RoomNo = "";
              this.SeatNo = "";
              this.Memo = "";
              this.roleList = [];
              this.$message({
                message: res.message,
                type: "success"
              });
              this.fetchData();
            } else {
              this.$toast(res.message);
            }
            if (res.code == 50000) {
              this.dialogVisible = false;
              this.$message.error(res.message);
              this.fetchData();
              return;
            }
          }
        );
      }
    },
    // 编辑工作人员  保存按鈕
    setUser () {
      // console.log(this.userSelList);
     if (this.userSelList.RoomNo == "") {
        Dialog.alert({
          title: "提示",
          message: "考场号不能为空"
        }).then(() => {
          // on close
        });
      } else if (this.userSelList.SeatNo == "") {
        Dialog.alert({
          title: "提示",
          message: "座位号不能为空"
        }).then(() => {
          // on close
        });
      } else if (this.userSelList.Memo == "") {
        Dialog.alert({
          title: "提示",
          message: "违纪情况不能为空"
        }).then(() => {
          // on close
        });
      }  else {
        console.log("RoomNo"+ this.userSelList.RoomNo)
          this.apiSetviolatedisciplineinfoAPIGet(
            {
              WorkID: this.getWork().WorkID,
              SplitProcessID: this.SplitProcessID,
              RoomNo: this.userSelList.RoomNo,
              SeatNo: this.userSelList.SeatNo,
              Memo: this.userSelList.Memo
            },
            this,
            res => {
              console.log("res.code:" + res.code)
              if (res.code == 20000) {
                this.userSelList = [];
                this.$message({
                  message: res.message,
                  type: "success"
                });
                this.fetchData();
                console.log("111")
                this.dialogShow = false;
                console.log("222")
              } else {
                this.$toast(res.message);
              }
              if (res.code == 50000) {
                // this.dialogVisible = false;
                this.$message.error(res.message);
                this.fetchData();
                return;
              }
            }
          );
        }
    },
    // 刪除工作人員
    removeUser (RoomNo,SeatNo) {
      Dialog.confirm({
        title: "提示",
        message: "此操作将永久删除, 是否继续?"
      })
        .then(() => {
          this.apiReportDelviolatedisciplineinfofoAPIGet(
            { WorkID: this.getWork().WorkID, SplitProcessID:this.SplitProcessID, RoomNo: RoomNo ,RoomNo,SeatNo:SeatNo},
            this,
            // eslint-disable-next-line no-unused-vars
            res => {
              this.fetchData();
            }
          );
          this.$message({
            type: "success",
            message: "删除成功!"
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除"
          });
        });
    },
    handleClose () {
      this.dialogVisible = false;
      this.dialogShow = false;
    }
  }
};
</script>

<style scoped>
.el-dialog__body {
  padding: 1px 20px;
  color: #606266;
  font-size: 14px;
  word-break: break-all;
}
</style>